/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Orders_Rate_ReadyInputs */

const en_orders_rate_ready = /** @type {(inputs: Orders_Rate_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rate ready: ${i?.amount}`)
};

const es_orders_rate_ready = /** @type {(inputs: Orders_Rate_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tarifa lista: ${i?.amount}`)
};

/**
* | output |
* | --- |
* | "Rate ready: {amount}" |
*
* @param {Orders_Rate_ReadyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_rate_ready = /** @type {((inputs: Orders_Rate_ReadyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Rate_ReadyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_rate_ready(inputs)
	return es_orders_rate_ready(inputs)
});